import { render, staticRenderFns } from "./CustomItemShowcase.vue?vue&type=template&id=fc5220ee&"
import script from "./CustomItemShowcase.vue?vue&type=script&lang=js&"
export * from "./CustomItemShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports